import { Box } from '@mui/material';
import type React from 'react';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import BaseEmbed from '../../../BaseEmbed';
import { EMBEDS_URL } from './constants';

export type Props = StructuredContentDocument<{
  id: string;
  height: number;
}>;

export default function CalculatedFieldsForm({ props: { id } }: Props): React.JSX.Element | null {
  if (!id) return null;
  const src = `${EMBEDS_URL}/cff/?form_id=${id}&nwaMode=embed`;

  return (
    <Box
      sx={{ boxShadow: '0 4px 8px 0 rgb(100 102 106 / 10%), 0 1px 4px 0 rgb(100 102 106 / 36%)' }}
    >
      <BaseEmbed src={src} title="Calculated Fields Form" />
    </Box>
  );
}
